import { z } from 'zod';

export const otpSchema = z.object({
  otp: z.string().min(6, {
    message: 'Your one-time password must be 6 characters.'
  })
});

export type OTPFormValues = z.infer<typeof otpSchema>;
